import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e9eaeb;
  border-radius: 12px;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  background: #fff;
  width: 100%;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #ffffff;
  border-bottom: 1px solid #e9eaeb;
`;

export const CardTitle = styled.h3`
  font-family: "Geist", sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #181d27;
  margin: 0;
`;

export const CardContent = styled.div`
  background: #fff;
  padding: 20px;
`;

export const ContentContainer = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 1400px) {
    flex-direction: column;
  }

  @media (max-width: 768px) {
    gap: 16px;
  }
`;
export const TreemapContainer = styled.div`
  position: relative;
  flex: 1;
  min-width: 300px;
  height: 420px;
  min-height: 420px;
  background-color: #f9fafb;
  border: 1px solid #e9eaeb;
  border-radius: 8px;
  overflow: hidden;
  aspect-ratio: 4 / 3;

  @media (max-width: 768px) {
    min-width: 280px;
    height: 300px;
    min-height: 300px;
  }
`;
export const TreemapRectangle = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 8px;
  border-radius: 6px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border: 1px solid rgba(255, 255, 255, 0.25);
  left: ${({ $x, $containerWidth }) => ($x / $containerWidth) * 100}%;
  top: ${({ $y, $containerHeight }) => ($y / $containerHeight) * 100}%;
  width: ${({ $width, $containerWidth }) => ($width / $containerWidth) * 100}%;
  height: ${({ $height, $containerHeight }) =>
    ($height / $containerHeight) * 100}%;
`;

export const RectangleName = styled.span`
  font-size: ${({ $fontSize }) => $fontSize || "0.8rem"};
  font-weight: 500;
  color: ${({ $textColor }) => $textColor || "#111827"};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 90%;
`;

export const RectanglePercentage = styled.span`
  font-size: ${({ $fontSize }) => $fontSize || "0.75rem"};
  color: ${({ $textColor }) => $textColor || "#374151"};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 90%;
`;

export const TableContainer = styled.div`
  flex: 0 0 300px;
  border-radius: 8px;
  background: #fff;
  padding: 16px;
`;

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #e9eaeb;
  margin-bottom: 8px;
`;

export const TableHeaderText = styled.span`
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #181d27;
`;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #e9eaeb;

  &:last-child {
    border-bottom: none;
  }
`;

export const TableRowLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ColorIndicator = styled.div`
  width: 12px;
  height: 28px;
  border-radius: 10px;
  background-color: ${({ $color }) => $color || "#6b7280"};
  flex-shrink: 0;
`;

export const IndustryName = styled.span`
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #181d27;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 180px;
`;

export const PercentageBadge = styled.span`
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #414651;
  background-color: #fafafa;
  padding: 4px 8px;
  border: 1px solid #e9eaeb;
  border-radius: 6px;
  min-width: 40px;
  text-align: center;
`;

export const ErrorText = styled.div`
  color: #ef4444;
  font-size: 14px;
  text-align: center;
  padding: 20px;
`;

export const MessageText = styled.div`
  color: #6b7280;
  font-size: 14px;
  text-align: center;
  padding: 20px;
`;
